// Complete Report evaluates every linked non-conformity while the actions
// menu renders. A key that is missing or null in the store throws
// `reading 'Completed'` inside Array.every.

export function nonConformitiesAllCompleted(items, state) {
    if (!Array.isArray(items)) return false;
    return items.length === 0 || items.every((key) => state?.[key]?.Completed == true);
}
